import { Select as AntdSelect } from "antd";
import { SelectProps } from "antd/lib";
import { twMerge } from "tailwind-merge";
import { useAutoSearch } from "./model/use-auto-search";

export type { SelectProps };

export function Select({ className, ...props }: SelectProps) {
  const search = useAutoSearch(props);

  return (
    <AntdSelect
      className={twMerge("w-full", className)}
      {...props}
      {...search}
    />
  );
}

Select.Option = AntdSelect.Option;
